<template>
  <div class="soil-remediation">
    <div class="container">
      <h1>场调/土壤修复</h1>
      <p class="subtitle">专业的场地环境调查、风险评估与修复治理服务</p>
      
      <!-- 核心服务内容 -->
      <div class="service-section">
        <h2 class="section-title">场地环境调查与风险评估</h2>
        <div class="section-content">
          <p class="intro-text">
            受政府或企业委托，对于拟关停搬迁和拟变更土地利用方式或者土地使用权人的工业企业场地，开展原址场地的环境调查与风险评估（包括污染识别、现场采样和风险评估三个阶段），经场地环境调查与风险评估认定为污染场地的，提出治理修复技术建议。
          </p>
        </div>
      </div>

      <!-- 公司优势 -->
      <div class="advantage-section">
        <h2 class="section-title">我们的优势</h2>
        <div class="advantage-list">
          <div class="advantage-item">
            <div class="advantage-number">1</div>
            <div class="advantage-content">
              <h3>专业人才多</h3>
            </div>
          </div>
          <div class="advantage-item">
            <div class="advantage-number">2</div>
            <div class="advantage-content">
              <h3>拥有场地环境调查、风险评估和修复治理知识以及经验的人才多</h3>
            </div>
          </div>
          <div class="advantage-item">
            <div class="advantage-number">3</div>
            <div class="advantage-content">
              <h3>污染场地监测、评价、治理、修复技术装备先进</h3>
            </div>
          </div>
        </div>
      </div>

      <!-- 污染场地修复咨询及治理 -->
      <div class="consultation-section">
        <h2 class="section-title">污染场地修复咨询及治理</h2>
        <div class="section-content">
          <p class="intro-text">
            为客户提供场地环境调查、现场采样监测、风险评估、修复方案编制、环境监理等污染场地修复的全过程技术咨询服务。
          </p>
          
          <div class="service-items">
            <!-- 场地环境调查 -->
            <div class="service-item">
              <h3>▲场地环境调查</h3>
              <p>
                针对场地的特征和污染物的特性，进行污染物浓度和空间分布的调查，为场地的环境管理提供依据。
              </p>
            </div>
            
            <!-- 风险评估 -->
            <div class="service-item">
              <h3>▲风险评估</h3>
              <p>
                通过对污染场地的危害识别、暴露评估、毒性评估、风险表征和风险控制值的确定，分析污染场地土壤和地下水中污染物进入人体的不同暴露途径，定量估算致癌污染物对人体健康产生危害的概率或非致癌污染物的危害水平。
              </p>
            </div>
            
            <!-- 修复方案编制 -->
            <div class="service-item">
              <h3>▲修复方案编制</h3>
              <p>
                通过对场地条件、污染物特征分析选择修复模式，分析实用修复技术，评估修复技术的可行性，确定修复技术，制定修复技术方案。
              </p>
            </div>
          </div>
        </div>
      </div>

      <!-- 场地环境调查阶段 -->
      <div class="stage-section">
        <h2 class="section-title">场地环境调查的三个工作阶段</h2>
        <div class="stage-list">
          <!-- 第一阶段 -->
          <div class="stage-item">
            <div class="stage-header">
              <div class="stage-number">第一阶段调查</div>
              <div class="stage-name">污染识别</div>
            </div>
            <div class="stage-content">
              <p>通过场地历史、生产工艺和环境事故等初步识别可疑污染源</p>
            </div>
          </div>
          
          <!-- 第二阶段 -->
          <div class="stage-item">
            <div class="stage-header">
              <div class="stage-number">第二阶段调查</div>
              <div class="stage-name">详细调查及补充调查</div>
            </div>
            <div class="stage-content">
              <p>通过点位布设、样品采集、检测分析确定污染因子、浓度范围以及空间分布，并对其扩散趋势进行预测</p>
            </div>
          </div>
          
          <!-- 第三阶段 -->
          <div class="stage-item">
            <div class="stage-header">
              <div class="stage-number">第三阶段调查</div>
              <div class="stage-name">风险评估</div>
            </div>
            <div class="stage-content">
              <p>通过计算污染源、暴露途径、敏感受体等特征参数进行暴露评估和毒性评估，确定最终关注污染物清理目标及修复目标值</p>
              <p class="stage-note">
                基于场地水文地质条件以及调查数据进行污染源和污染羽的扩散模拟，结合场地关注污染物暴露特征参数和毒性特征参数对人体健康风险进行计算，最终确定场地风险控制值、修复目标值以及修复范围。
              </p>
            </div>
          </div>
        </div>
      </div>


    </div>
  </div>
</template>

<script>
export default {
  name: 'AppSoilRemediation'
}
</script>

<style scoped>
.soil-remediation {
  padding: 80px 0;
  background: linear-gradient(135deg, #f9f9f9 0%, #e6f3ee 100%);
}

.container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 20px;
}

 h1 {
  font-size: 36px;
  margin-bottom: 15px;
  color: #333;
  text-align: center;
}

.subtitle {
  text-align: center;
  font-size: 18px;
  color: #666;
  margin-bottom: 60px;
}

@media screen and (max-width: 768px) {
  .soil-remediation {
    padding: 60px 0;
  }

  h1 {
    font-size: 28px;
  }

  .subtitle {
    font-size: 16px;
    margin-bottom: 40px;
  }
}

@media screen and (max-width: 480px) {
  .soil-remediation {
    padding: 40px 0;
  }

  h1 {
    font-size: 24px;
  }

  .subtitle {
    font-size: 14px;
    margin-bottom: 30px;
  }
}

/* 通用部分样式 */
.service-section,
.advantage-section,
.consultation-section,
.stage-section {
  margin-bottom: 80px;
  background-color: #fff;
  padding: 40px;
  border-radius: 8px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
}

.section-title {
  font-size: 28px;
  color: #333;
  margin-bottom: 30px;
  padding-bottom: 15px;
  border-bottom: 3px solid #42b983;
}

.section-content .intro-text {
  font-size: 16px;
  color: #333;
  line-height: 1.8;
  margin-bottom: 40px;
}

@media screen and (max-width: 768px) {
  .service-section,
  .advantage-section,
  .consultation-section,
  .stage-section {
    margin-bottom: 60px;
    padding: 30px;
  }

  .section-title {
    font-size: 24px;
  }

  .section-content .intro-text {
    font-size: 14px;
  }
}

@media screen and (max-width: 480px) {
  .service-section,
  .advantage-section,
  .consultation-section,
  .stage-section {
    margin-bottom: 40px;
    padding: 20px;
  }

  .section-title {
    font-size: 20px;
  }

  .section-content .intro-text {
    font-size: 13px;
  }
}

/* 优势列表样式 */
.advantage-list {
  display: flex;
  flex-direction: column;
  gap: 20px;
}

.advantage-item {
  display: flex;
  align-items: center;
  padding: 20px;
  background-color: #f9f9f9;
  border-radius: 8px;
  transition: transform 0.3s ease, box-shadow 0.3s ease;
}

.advantage-item:hover {
  transform: translateY(-5px);
  box-shadow: 0 8px 20px rgba(0, 0, 0, 0.1);
}

.advantage-number {
  flex-shrink: 0;
  width: 50px;
  height: 50px;
  line-height: 50px;
  text-align: center;
  background-color: #42b983;
  color: #fff;
  font-size: 24px;
  font-weight: bold;
  border-radius: 50%;
  margin-right: 20px;
}

.advantage-content h3 {
  font-size: 18px;
  color: #333;
  font-weight: 600;
  margin: 0;
}

@media screen and (max-width: 768px) {
  .advantage-item {
    padding: 15px;
  }

  .advantage-number {
    width: 40px;
    height: 40px;
    line-height: 40px;
    font-size: 20px;
    margin-right: 15px;
  }

  .advantage-content h3 {
    font-size: 16px;
  }
}

@media screen and (max-width: 480px) {
  .advantage-item {
    padding: 12px;
  }

  .advantage-number {
    width: 35px;
    height: 35px;
    line-height: 35px;
    font-size: 18px;
    margin-right: 12px;
  }

  .advantage-content h3 {
    font-size: 14px;
  }
}

/* 服务项目样式 */
.service-items {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(350px, 1fr));
  gap: 30px;
}

.service-item {
  background-color: #f9f9f9;
  padding: 30px;
  border-radius: 8px;
  transition: transform 0.3s ease, box-shadow 0.3s ease;
}

.service-item:hover {
  transform: translateY(-5px);
  box-shadow: 0 8px 20px rgba(0, 0, 0, 0.1);
}

.service-item h3 {
  font-size: 20px;
  color: #333;
  margin-bottom: 15px;
  font-weight: 600;
}

.service-item p {
  font-size: 14px;
  color: #666;
  line-height: 1.7;
  margin: 0;
}

@media screen and (max-width: 768px) {
  .service-items {
    grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
    gap: 20px;
  }

  .service-item {
    padding: 20px;
  }

  .service-item h3 {
    font-size: 18px;
  }

  .service-item p {
    font-size: 13px;
  }
}

@media screen and (max-width: 480px) {
  .service-items {
    grid-template-columns: 1fr;
  }

  .service-item {
    padding: 15px;
  }

  .service-item h3 {
    font-size: 16px;
  }

  .service-item p {
    font-size: 12px;
  }
}

/* 阶段列表样式 */
.stage-list {
  display: flex;
  flex-direction: column;
  gap: 25px;
}

.stage-item {
  background-color: #f9f9f9;
  border-radius: 8px;
  overflow: hidden;
  transition: transform 0.3s ease, box-shadow 0.3s ease;
}

.stage-item:hover {
  transform: translateY(-5px);
  box-shadow: 0 8px 20px rgba(0, 0, 0, 0.1);
}

.stage-header {
  display: flex;
  background-color: #42b983;
  color: #fff;
  padding: 20px;
  font-weight: 600;
}

.stage-number {
  flex-shrink: 0;
  margin-right: 20px;
  font-size: 16px;
}

.stage-name {
  font-size: 18px;
}

.stage-content {
  padding: 20px;
  background-color: #fff;
}

.stage-content p {
  font-size: 14px;
  color: #333;
  line-height: 1.7;
  margin-bottom: 15px;
}

.stage-content p:last-child {
  margin-bottom: 0;
}

.stage-note {
  color: #666;
  font-style: italic;
}

@media screen and (max-width: 768px) {
  .stage-header {
    padding: 15px;
  }

  .stage-number {
    margin-right: 15px;
    font-size: 14px;
  }

  .stage-name {
    font-size: 16px;
  }

  .stage-content {
    padding: 15px;
  }

  .stage-content p {
    font-size: 13px;
  }
}

@media screen and (max-width: 480px) {
  .stage-header {
    padding: 12px;
    flex-direction: column;
    gap: 5px;
  }

  .stage-number {
    margin-right: 0;
    font-size: 13px;
  }

  .stage-name {
    font-size: 15px;
  }

  .stage-content {
    padding: 12px;
  }

  .stage-content p {
    font-size: 12px;
  }
}


</style>